import { render } from "./ValidatePage.vue?vue&type=template&id=990e22b6&scoped=true"
import script from "./ValidatePage.vue?vue&type=script&lang=js"
export * from "./ValidatePage.vue?vue&type=script&lang=js"

import "./ValidatePage.vue?vue&type=style&index=0&id=990e22b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-990e22b6"]])

export default __exports__